import { BaseList } from "App/Screens/SubModules/Component";
import descriptor from "./descriptorOffline";

class TransitionList extends BaseList {
  constructor(props) {
    super(props)

    this.appName = 'jobs'
    this.modelName = 'jobstatustransition'
    this.availablePermissions = ['.view_']
    this.propsList = {
      avatar: 'action_name',
      pageTitle: 'Transition',
      descriptor,
      masterKey: 'module-job-transition',
    }
    this.state = {
      ...this.state,
      currentPermissionSet: this.isSuperuser ? this.availablePermissions : [],
    }
  }
}

export default TransitionList